enum SPECIFIC_ERROR_CODES {
  INVOICE_ALREADY_PAID = 'Reverse.Claim.Errors.ClaimGroup.InvoiceAlreadyPaid',
  INVALID_EMAIL_ADDRESS = 'InvalidEmailAddress',
}

export default SPECIFIC_ERROR_CODES;
